module.exports = __webpack_public_path__ + "static/media/arrow-down.fd4c4aef.svg";